// extracted by mini-css-extract-plugin
export default {"join":"ForPublishers_join__sKVcf","contactUs":"ForPublishers_contactUs__NUWh1"};